import {MatDialogConfig} from '@angular/material/dialog';

export const dialogDefaultConfig: MatDialogConfig = {
  hasBackdrop: true,
  direction: 'ltr',
}
